import { Controller } from 'react-hook-form';

import { Budget } from '@/components/pages/edit-campaign/form-elements/budget';
import { Dates } from '@/components/pages/edit-campaign/form-elements/dates';
import { TargetBudget } from '@/components/pages/edit-campaign/target-budget';
import { Label } from '@/components/ui/label';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';
import { Tooltip } from '@/components/ui/tooltip';
import { useEditCampaignContext } from '@/contexts/edit-campaign-context';
import { useIndeedEndDateTypeOptions } from '@/hooks/use-indeed-end-date-type-options';

export function IndeedForm() {
  const { campaign, hookForm, isCompleted } = useEditCampaignContext();
  const isReadonly = campaign?.is_readonly;
  const { control } = hookForm;
  const endAtTypeOptions = useIndeedEndDateTypeOptions();

  return (
    <>
      <Dates />

      <Controller
        control={control}
        name="end_at_type"
        render={({ field }) => (
          <RadioGroup
            onValueChange={field.onChange}
            value={field.value}
            className="flex flex-col gap-6"
            disabled={isCompleted || isReadonly}
          >
            {endAtTypeOptions.map(option => (
              <Tooltip
                key={option.value}
                content={option.description}
                className="w-80"
              >
                <div className="flex w-fit items-center space-x-2">
                  <RadioGroupItem value={option.value} id={option.value} />
                  <Label htmlFor={option.value}>{option.label}</Label>
                </div>
              </Tooltip>
            ))}
          </RadioGroup>
        )}
      />

      <Budget />
      <TargetBudget />
    </>
  );
}
